import { toast } from "react-toastify";



export const success = (message) => {
    toast.success(message, {
        position: "bottom-left"
    });
}

export const errorToast = (message) => {
    toast.error(message, {
        position: "bottom-left"
    });
}

export const infoToast = (message) => {
    toast.info(message, {
        position: "bottom-left"
    });
}

export const successDefault = () => {
    success("Operação Realizado com Sucesso.");
}